import { User } from 'src/store/models/index.js'
import Registration from 'src/api/registration.js'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

const defaultState = () => ({
  user: null,
  steps: [],
  grades: [],
  roles: [],
  shortcuts: []
})

export const state = defaultState()

export const mutations = {
  RESET_STATE (state) {
    Object.assign(state, defaultState())
  },
  SET_STEPS (state, steps) {
    state.steps = steps
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_GENERAL_INFORMATION (state, information) {
    state.grades = Object.values(information.grades || {})
    state.shortcuts = information.shortcuts || []
    state.roles = information.roles || []
  }
}
export const actions = {
  // Fetch steps from api:
  async checkActivationKey ({ commit, dispatch }, code, school_id) {
    // TODO queryparamter

    const res = await Registration.getActivationKeySteps({ params: code, school_id })
    const locale = res.data.user?.locale
    commit('SET_SCHOOL', res.data.user?.school, { root: true })
    commit('SET_STEPS', res.data.steps)

    const userRelations = await User.create({ data: res.data.user })
    locale && await GlobalPrototypes.switchLocale(locale)
    commit('SET_USER', userRelations.users[0])
    await dispatch('getExtraInformation', code)

    return true
  },
  async getExtraInformation ({ commit, state }) {
    const { code, school_id, firstname, lastname, sex } = state.user
    const information = await Registration.getInformation({ params: { code, school_id, firstname, lastname, sex } })
    commit('SET_GENERAL_INFORMATION', information.data)
  }
}
